import { BaseModel } from 'paliari-js-utils'
import Cidade from './Cidade'
import Bairro from './Bairro'
import Logradouro from './Logradouro'

const attributes = {
  numero: '',
  complemento: '',
  cep: '',
  cidade: obj => new Cidade(obj),
  bairro: obj => new Bairro(obj),
  logradouro: obj => new Logradouro(obj),
}

class Endereco extends BaseModel {
  constructor(obj = {}) {
    super(attributes, obj)
  }
}

export default Endereco
